import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { IconCompass } from '@tabler/icons-react';
import { FC } from 'react';

import mobileClasses from '../../styles/farmer-mobile.module.css';
import { deviceOrientationIdleHint } from '../../utils/device-orientation-platform';

import classes from './device-orientation-prompt.module.css';

interface DeviceOrientationPromptProps {
  orientationError: string | null;
  isRequesting: boolean;
  needsPermission: boolean;
  onActivate: () => void;
}

export const DeviceOrientationPrompt: FC<DeviceOrientationPromptProps> = ({
  orientationError,
  isRequesting,
  needsPermission,
  onActivate,
}) => {
  if (!needsPermission && !orientationError) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Stack gap="sm">
        <Group align="flex-start" gap="sm" wrap="nowrap">
          <Box className={classes.icon}>
            <IconCompass size={22} stroke={1.75} />
          </Box>
          <Stack gap={4} style={{ flex: 1 }}>
            <Text fw={600} size="sm">
              {orientationError ? 'Boussole requise' : 'Activez la boussole'}
            </Text>
            <Text c="dimmed" size="sm">
              {orientationError ??
                `${deviceOrientationIdleHint()} Le cap sera enregistré avec la photo.`}
            </Text>
          </Stack>
        </Group>
        <Button
          className={mobileClasses.touchButton}
          fullWidth
          leftSection={<IconCompass size={20} />}
          loading={isRequesting}
          onClick={onActivate}
          size="lg"
          type="button"
        >
          {orientationError ? 'Réessayer' : 'Activer la boussole'}
        </Button>
      </Stack>
    </Box>
  );
};
